const s = "message", e = "message__content", a = "message__type", m = {
  message: s,
  message__content: e,
  message__type: a,
  "message__close-button": "message__close-button",
  "message--closed": "message--closed",
  "message--success": "message--success",
  "message--error": "message--error",
  "message--info": "message--info",
  "message--small": "message--small"
};
export {
  m as default,
  s as message,
  e as message__content,
  a as message__type
};
